import actionTypes from '../actions/actionTypes'
import { parse } from 'qs'

const defaultState = {
	step: -1,
	maxVisitedStep: -1,
	transitioning: -1,
	loadedAssets: 0,
	activatedLessons: 0,
	loopComplete: 0,
	loadingComplete: false,
	selected: [],
	suggested: [],
	grades: [],
	subjects: [],
	saved_grades: [],
	saved_subjects: [],
	technology: [],
	interests: [],
	subjects_updated: false,
	grades_updated: false,
	previewID: '',
	fromStore: false,
	visit_time: 0,
	number_of_previews: 0,
}

function changeStep(state, action) {
	const isNewStep = state.step !== action.step
	const newState = {
		...state,
		...{
			step: action.step,
			maxVisitedStep: Math.max(state.maxVisitedStep, action.step),
			loadedAssets: 0,
			activatedLessons: 0,
			loopComplete: 0,
			loadingComplete: false,
			selected: [],
			suggested: [],
			visit_time: Date.now(),
		},
	}
	action.fromStore = state.fromStore
	action.isNewStep = isNewStep
	return newState
}

function transitionStep(state) {
	const newState = {...state, ...{transitioning: state.step}}
	return newState
}

function resetTransitioning(state) {
	const newState = {...state, ...{transitioning: -1}}
	return newState
}

function assetLoaded(state) {
	if (state.step !== 3) {
		return state
	}
	const newState = {...state, ...{loadedAssets: state.loadedAssets+1}}
	return newState
}

function lessonActivated(state) {
	const newState = {...state, ...{activatedLessons: state.activatedLessons+1}}
	return newState
}

function loopComplete(state) {
	if (state.loopComplete > 1) {
		return state
	}
	const newState = {...state, ...{loopComplete: state.loopComplete + 1}}
	return newState
}

function loadingComplete(state) {
	const newState = {...state, ...{loadingComplete: true}}
	return newState
}

function updateGrades(state, action) {
	const newState = {...state, ...{grades: action.grades, grades_updated: true}}
	return newState
}

function updateSubjects(state, action) {
	const newState = {...state, ...{subjects: action.subjects, subjects_updated: true}}
	return newState
}

function updateTechnology(state, action) {
	const newState = {...state, ...{technology: action.technology}}
	return newState
}

function updateInterests(state, action) {
	const newState = {...state, ...{interests: action.interests}}
	return newState
}

function updateSuggestedLessons(state, action) {
	const newState = {...state}
	newState.suggested = action.entities.map(function(item) {
		return item.data.entityUID
	})
	return newState
}

function toggleLessonSelection(state, action) {
	const newState = {...state}
	const ind = state.selected.indexOf(action.entityUID)
	if (ind === -1) {
		newState.selected = [...state.selected, action.entityUID]
		action._selected = true
	} else {
		newState.selected = [...state.selected.slice(0, ind), ...state.selected.slice(ind + 1)]
	}
	return newState
}

function initializeOnboarding(state, action) {
	const newState = {...state}
	const query = parse(action.location)
	if (query.from_store) {
		newState.fromStore = true
	}
	if (action.params.step) {
		newState.step = parseInt(action.params.step)
	} else {
		newState.step = 0
	}
	newState.visit_time = Date.now()
	newState.maxVisitedStep = Math.max(state.maxVisitedStep, newState.step)
	return newState
}

function setPreviewId(state, action) {
	const newState = {...state, ...{previewID: action.previewID, number_of_previews: state.number_of_previews + 1}}
	return newState
}

function closePreview(state) {
	const newState = {...state, ...{previewID: ''}}
	return newState
}

function subjectsSaved(state, action) {
	const newState = {...state}
	newState.saved_subjects = action.subjects
	return newState
}

function gradesSaved(state, action) {
	const newState = {...state}
	newState.saved_grades = action.grades
	return newState
}

function interestSelected(state, action) {
	const newState = {...state}
	const interestIndex = newState.interests.indexOf(action.id)
	if (interestIndex === -1) {
		newState.interests = [...state.interests, action.id]
	} else {
		newState.interests = [...state.interests.slice(0, interestIndex), ...state.interests.slice(interestIndex + 1)]
	}
	return newState
}

function technologySelected(state, action) {
	const newState = {...state}
	newState.technology = [action.id]
	return newState
}

const onboardingReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.ONBOARDING_CHANGE_STEP: {
			return changeStep(state, action)
		}
		case actionTypes.ONBOARDING_INITIALIZE: {
			return initializeOnboarding(state, action)
		}
		case actionTypes.ONBOARDING_RESET_STEP_TRANSITION: {
			return resetTransitioning(state, action)
		}
		case actionTypes.ONBOARDING_LESSON_ASSET_LOADED: {
			return assetLoaded(state, action)
		}
		case actionTypes.ONBOARDING_LESSON_ACTIVATED: {
			return lessonActivated(state, action)
		}
		case actionTypes.ONBOARDING_LOOP_COMPLETE: {
			return loopComplete(state, action)
		}
		case actionTypes.ONBOARDING_LOADING_COMPLETE: {
			return loadingComplete(state, action)
		}
		case actionTypes.ONBOARDING_GRADES_UPDATED: {
			return updateGrades(state, action)
		}
		case actionTypes.ONBOARDING_SUBJECTS_UPDATED: {
			return updateSubjects(state, action)
		}
		case actionTypes.ONBOARDING_TECHNOLOGY_UPDATED: {
			return updateTechnology(state, action)
		}
		case actionTypes.ONBOARDING_INTERESTS_UPDATED: {
			return updateInterests(state, action)
		}
		case actionTypes.ONBOARDING_SUGGESTED_LESSONS_FETCHED: {
			return updateSuggestedLessons(state, action)
		}
		case actionTypes.ONBOARDING_LESSON_SELECTED: {
			return toggleLessonSelection(state, action)
		}
		case actionTypes.ONBOARDING_PREVIEW_SELECTED: {
			return setPreviewId(state, action)
		}
		case actionTypes.ONBOARDING_PREVIEW_CLOSE: {
			return closePreview(state, action)
		}
		case actionTypes.ONBOARDING_TRANSITION_STEP: {
			return transitionStep(state, action)
		}
		case actionTypes.ONBOARDING_SUBJECTS_SAVED: {
			return subjectsSaved(state, action)
		}
		case actionTypes.ONBOARDING_GRADES_SAVED: {
			return gradesSaved(state, action)
		}
		case actionTypes.ONBOARDING_SELECT_INTERESTS: {
			return interestSelected(state, action)
		}
		case actionTypes.ONBOARDING_SELECT_TECHNOLOGY: {
			return technologySelected(state, action)
		}
		default:
			return state
	}
}

export default onboardingReducer
